import { useState } from 'react';
import { toast } from 'sonner';

import { connectOAuthIntegration } from '@/integrations/integration-handlers';
import { userStore } from '@/stores/user.store';

export function useConnectCalendar() {
  const [isConnecting, setIsConnecting] = useState(false);

  const connect = async () => {
    if (isConnecting) return;
    setIsConnecting(true);

    const fail = () => {
      setIsConnecting(false);
      toast.error('Failed to connect calendar. Please try again.');
    };

    try {
      const result = await connectOAuthIntegration(
        'googlecalendar',
        'Google Calendar',
        undefined,
        (success: boolean) => {
          setIsConnecting(false);
          if (success) userStore.refresh();
        }
      );

      if (!result.success && !result.needsOAuth) fail();
    } catch (error) {
      console.error('Failed to connect calendar:', error);
      fail();
    }
  };

  return { isConnecting, connect };
}
